import React from 'react';
import {
  getDetailCommonValidUrlParams,
  getCountriesActiveuserRevDownValidUrlParams,
  statsDownloadValidCfg,
  countriesDownloadValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import { ActiveuerRevDownCom } from './Activeuser';

export default function Downloads(props: any) {
  const { tabType, pageId } = props;
  const isCoutriesPage = tabType === 'countries';
  const currentValidCfg = isCoutriesPage ? countriesDownloadValidCfg : statsDownloadValidCfg;
  const getValidUrlParams = isCoutriesPage ? getCountriesActiveuserRevDownValidUrlParams : getDetailCommonValidUrlParams;
  // 是否有短链接更新功能
  const hasUrlShortLink = isCoutriesPage ? hasShortLinkRatio.detailMobileCountriesDownload : hasShortLinkRatio.detailMobileStatsDownload;

  if (pageId !== 'downloads') {
    return null;
  }

  return (
    <ActiveuerRevDownCom
      {...props}
      hasUrlShortLink={hasUrlShortLink}
      isCoutriesPage={isCoutriesPage}
      currentValidCfg={currentValidCfg}
      getValidUrlParams={getValidUrlParams}
      chartSegment={'sum_download'}

    />
  );
}
